import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["count", "type", "disabled", "position"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useTheme } from "@emotion/react";
import PropTypes from "prop-types";
import React from "react";
import { BADGE_TYPES, MAX_BADGE_COUNT, MAX_COUNTER } from "./constants";
import extractTheme from "./extractTheme";
/**
 *
 * Badge is private component that serves a visual indicator for the numerical
 * value of a BadgeButton or Icon.
 *
 */

import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";

function Badge(_ref) {
  let {
    count,
    type,
    disabled,
    position
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  const theme = useTheme();
  let displayedCounter = null;

  if (count !== true && Number(count) && Number(count) > 0) {
    const dataCount = Number(count);
    displayedCounter = dataCount > MAX_COUNTER ? MAX_BADGE_COUNT : dataCount;
  }

  const {
    cssRoot
  } = extractTheme({
    theme,
    type,
    position
  });
  return !disabled ? _jsxs("span", _objectSpread(_objectSpread({
    className: "pnr-badge",
    css: cssRoot
  }, otherProps), {}, {
    children: [type === "counter" && " ", displayedCounter]
  })) : null;
}

Badge.propTypes = process.env.NODE_ENV !== "production" ? {
  /** The number to be displayed in the Badge. */
  count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** Whether or not the Badge should be displayed. */
  disabled: PropTypes.bool,

  /** Optional positioning for absolute positioned Badge. */
  position: PropTypes.shape({
    /** Top position for Badge. */
    top: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

    /** Right position for Badge. */
    right: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

    /** Bottom position for Badge. */
    bottom: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

    /** Left position for Badge. */
    left: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  }),
  type: PropTypes.oneOf(BADGE_TYPES)
} : {};
Badge.defaultProps = {
  count: null,
  disabled: false,
  position: null,
  type: "badge"
};
export default Badge;